import * as React from 'react';
import nouislider from 'nouislider';
import { AnalyticsTrigger } from '@telia-front/analytics';
import { debounce } from '@telia-front/helper';
import Icon from '@telia-front/icon';
const Slider = (props) => {
    return (React.createElement(AnalyticsTrigger, { trigger: {
            callback: 'onChange',
            id: `Slider - ${props.id}`,
            elementId: props.id,
            elementType: 'slider',
            interactionType: 'select',
        } },
        React.createElement(SliderInner, Object.assign({}, props))));
};
export class SliderInner extends React.Component {
    static isStartEqual(start, prevStart) {
        if (typeof start === 'number' && typeof prevStart === 'number') {
            return start === prevStart;
        }
        if (Array.isArray(start) && Array.isArray(prevStart)) {
            return start[0] === prevStart[0] && start[1] === prevStart[1];
        }
        return false;
    }
    constructor(props) {
        super(props);
        this.sliderContainer = null;
        this.lowerHandle = null;
        this.upperHandle = null;
        this.lowerTooltip = null;
        this.upperTooltip = null;
        this.collapsedTooltip = null;
        this.sliderConnect = null;
        this.origin = [];
        this.slider = null;
        this.tooltipStyleInterval = 0;
        this.tooltipStyleTimeout = 0;
        this.onDrag = () => {
            if (this.lowerHandle && this.lowerHandle.classList.contains('slider__active')) {
                this.handleTooltip(this.lowerHandle, this.lowerTooltip);
            }
            if (this.upperHandle && this.upperHandle.classList.contains('slider__active')) {
                this.handleTooltip(this.upperHandle, this.upperTooltip);
            }
            this.handleChange();
        };
        this.checkTooltipCollision = () => {
            if (this.lowerTooltip && this.upperTooltip) {
                const lowerTooltipRight = this.lowerTooltip.getBoundingClientRect().right;
                const upperTooltipLeft = this.upperTooltip.getBoundingClientRect().left;
                const padding = 5;
                if (lowerTooltipRight + padding >= upperTooltipLeft) {
                    this.lowerTooltip.classList.add('slider__tooltip--hidden');
                    this.upperTooltip.classList.add('slider__tooltip--hidden');
                    this.collapseTooltips();
                }
                else {
                    this.lowerTooltip.classList.remove('slider__tooltip--hidden');
                    this.upperTooltip.classList.remove('slider__tooltip--hidden');
                    this.unCollapseTooltips();
                }
            }
            if (this.state.tooltipsCollapsed) {
                this.setCollapsedTooltipPosition();
            }
        };
        this.handleChange = () => {
            this.handleTooltip(this.lowerHandle, this.lowerTooltip);
            this.handleTooltip(this.upperHandle, this.upperTooltip);
            if (!this.tooltipStyleInterval) {
                this.tooltipStyleInterval = window.setInterval(() => {
                    this.handleChange();
                }, 1000 / 60);
                // sometimes transitionend event does not fire
                // so let's clear the interval when transition should be over.
                window.clearTimeout(this.tooltipStyleTimeout);
                this.tooltipStyleTimeout = window.setTimeout(() => {
                    window.clearInterval(this.tooltipStyleInterval);
                    this.tooltipStyleInterval = 0;
                }, 300);
            }
            this.checkTooltipCollision();
        };
        this.handleTransitionEnd = (event) => {
            if (event.target && event.target instanceof Element && this.origin.includes(event.target) && event.propertyName === 'transform') {
                window.clearTimeout(this.tooltipStyleTimeout);
                window.clearInterval(this.tooltipStyleInterval);
                this.tooltipStyleInterval = 0;
                this.handleChange();
            }
        };
        this.changeToOldValue = () => {
            // Change back noUiSlider value when user selects disabled value by dragging.
            if (this.slider && this.toNumber(this.slider.get()) !== this.state.value) {
                this.slider.set(this.state.value);
            }
        };
        this.renderPip = (pip, index) => {
            // Calculate pip position in slider
            const total = this.props.range.max - this.props.range.min;
            let position = ((pip.value - this.props.range.min) / total) * 100;
            if (this.props.direction === 'rtl') {
                position = 100 - position;
            }
            const onClick = () => this.onPipClick(pip.value);
            return (React.createElement("div", { key: index, className: this.pipBEM(pip), style: this.getPipStyle(pip.value, position), onClick: !pip.disabled ? onClick : undefined },
                React.createElement("div", { className: "slider__pip-inner" },
                    React.createElement("div", { className: "slider__pip-label" }, pip.label ? pip.label : `${pip.value}${this.props.unit}`),
                    pip.showAsterisk && React.createElement(Icon, { className: "slider__pip-icon", modifiers: "#star" }))));
        };
        this.lowerHandleMouseOverHandler = this.onLowerHandleMouseOver.bind(this);
        this.lowerHandleMouseOutHandler = this.onLowerHandleMouseOut.bind(this);
        this.upperHandleMouseOverHandler = this.onUpperHandleMouseOver.bind(this);
        this.upperHandleMouseOutHandler = this.onUpperHandleMouseOut.bind(this);
        this.state = {
            collapsedTooltipStyles: {},
            tooltipsCollapsed: false,
            value: this.props.start,
        };
        this.debouncedResizeHandler = debounce(this.checkTooltipCollision.bind(this), 100);
    }
    componentDidUpdate(prevProps) {
        if (this.slider && !SliderInner.isStartEqual(this.props.start, prevProps.start)) {
            this.slider.set(this.props.start);
            this.slider.updateOptions({
                range: this.props.range,
                start: this.props.start,
            }, false);
            this.setState({
                value: this.props.start,
            });
        }
        if (this.slider) {
            if (prevProps.range.min !== this.props.range.min ||
                prevProps.range.max !== this.props.range.max ||
                Object.keys(prevProps.range).length !== Object.keys(this.props.range).length) {
                this.slider.updateOptions({
                    range: this.props.range,
                    start: this.props.start,
                }, false);
            }
            if (prevProps.unit !== this.props.unit) {
                this.slider.updateOptions({
                    format: this.setUnit(this.props.unit),
                    range: this.props.range,
                    start: this.props.start,
                }, false);
            }
            if (prevProps.step !== this.props.step) {
                this.slider.updateOptions({
                    range: this.props.range,
                    start: this.props.start,
                    step: this.props.step,
                }, false);
            }
            if (prevProps.tooltips !== this.props.tooltips) {
                this.slider.updateOptions({
                    range: this.props.range,
                    start: this.props.start,
                    tooltips: this.props.tooltips,
                }, false);
            }
        }
        if (this.isSliderDisabled()) {
            this.removeListeners();
        }
    }
    componentDidMount() {
        this.addSlider();
        window.addEventListener('resize', this.debouncedResizeHandler);
    }
    componentWillUnmount() {
        this.removeSlider();
        window.removeEventListener('resize', this.debouncedResizeHandler);
        window.clearTimeout(this.tooltipStyleTimeout);
        window.clearInterval(this.tooltipStyleInterval);
        this.debouncedResizeHandler.clear();
    }
    BEM() {
        const classArray = ['slider'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    addSlider() {
        const cssPrefix = 'slider__';
        const { range, start, step, tooltips, direction } = this.props;
        const format = this.setUnit(this.props.unit);
        const sliderOptions = {
            connect: true,
            cssPrefix,
            direction,
            format,
            range,
            start,
            step,
            tooltips,
        };
        if (this.sliderContainer) {
            this.slider = nouislider.create(this.sliderContainer, sliderOptions);
        }
        if (this.slider && this.sliderContainer) {
            this.slider.on('start', this.onStart.bind(this));
            this.slider.on('slide', this.onDrag);
            this.slider.on('update', this.onUpdate.bind(this));
            this.slider.on('change', this.changeValue.bind(this));
            this.slider.on('end', this.onEnd.bind(this));
            const handles = this.sliderContainer.querySelectorAll('.slider__handle');
            this.lowerHandle = handles[0];
            this.upperHandle = handles[1];
            this.sliderConnect = this.sliderContainer.querySelector('.slider__connect');
            const sliderTooltips = this.sliderContainer.querySelectorAll('.slider__tooltip');
            this.lowerTooltip = sliderTooltips[0];
            this.upperTooltip = sliderTooltips[1];
            this.origin = Array.from(this.sliderContainer.querySelectorAll('.slider__origin'));
            this.addListeners();
            this.handleChange();
        }
    }
    onStart(values) {
        if (Array.isArray(values) && this.sliderContainer) {
            const handles = this.sliderContainer.querySelectorAll('.slider__handle');
            const connect = this.sliderContainer.querySelector('.slider__connect');
            // needed because nouislider doesn't add it on phone.
            this.sliderContainer.classList.add('slider__state-drag');
            if (handles[0].classList.contains('slider__active') && connect) {
                connect.classList.add('slider__connect--reverse');
            }
            else {
                if (connect) {
                    connect.classList.remove('slider__connect--reverse');
                }
            }
        }
    }
    onEnd() {
        if (this.sliderContainer) {
            this.sliderContainer.classList.remove('slider__state-drag');
        }
        window.clearTimeout(this.tooltipStyleTimeout);
        window.clearInterval(this.tooltipStyleInterval);
        this.tooltipStyleInterval = 0;
        this.handleChange();
    }
    addListeners() {
        if (this.sliderContainer) {
            this.sliderContainer.addEventListener('transitionend', this.handleTransitionEnd);
        }
        if (this.lowerHandle && !this.isSliderDisabled()) {
            this.lowerHandle.addEventListener('mouseover', this.lowerHandleMouseOverHandler);
            this.lowerHandle.addEventListener('mouseout', this.lowerHandleMouseOutHandler);
        }
        if (this.upperHandle && !this.isSliderDisabled()) {
            this.upperHandle.addEventListener('mouseover', this.upperHandleMouseOverHandler);
            this.upperHandle.addEventListener('mouseout', this.upperHandleMouseOutHandler);
        }
    }
    removeListeners() {
        if (this.sliderContainer) {
            this.sliderContainer.removeEventListener('transitionend', this.handleTransitionEnd);
        }
        if (this.lowerHandle) {
            this.lowerHandle.removeEventListener('mouseover', this.lowerHandleMouseOverHandler);
            this.lowerHandle.removeEventListener('mouseout', this.lowerHandleMouseOutHandler);
        }
        if (this.upperHandle) {
            this.upperHandle.removeEventListener('mouseover', this.upperHandleMouseOverHandler);
            this.upperHandle.removeEventListener('mouseout', this.upperHandleMouseOutHandler);
        }
    }
    removeSlider() {
        if (this.slider) {
            this.slider.destroy();
        }
        this.removeListeners();
    }
    onLowerHandleMouseOver() {
        if (this.lowerHandle && this.sliderContainer) {
            this.lowerHandle.classList.add('slider__hover');
            this.sliderContainer.classList.add('slider__state-hover');
        }
        if (this.sliderConnect) {
            this.sliderConnect.classList.add('slider__connect--reverse');
        }
    }
    onLowerHandleMouseOut() {
        if (this.lowerHandle && this.sliderContainer) {
            this.lowerHandle.classList.remove('slider__hover');
            this.sliderContainer.classList.remove('slider__state-hover');
        }
    }
    onUpperHandleMouseOver() {
        if (this.upperHandle && this.sliderContainer) {
            this.upperHandle.classList.add('slider__hover');
            this.sliderContainer.classList.add('slider__state-hover');
        }
        if (this.sliderConnect) {
            this.sliderConnect.classList.remove('slider__connect--reverse');
        }
    }
    onUpperHandleMouseOut() {
        if (this.upperHandle && this.sliderContainer) {
            this.upperHandle.classList.remove('slider__hover');
            this.sliderContainer.classList.remove('slider__state-hover');
        }
    }
    isSliderDisabled() {
        const { disabled, pips } = this.props;
        if (disabled) {
            return disabled;
        }
        if (!pips) {
            return false;
        }
        return !pips.filter((pip) => !pip.disabled).length;
    }
    setCollapsedTooltipPosition() {
        if (this.lowerHandle && this.upperHandle && this.sliderContainer && this.collapsedTooltip) {
            const containerPadding = 10;
            const containerRect = this.sliderContainer.getBoundingClientRect();
            const containerLeft = containerRect.left - containerPadding;
            const containerRight = containerRect.right + containerPadding;
            const containerWidth = containerRect.width + containerPadding * 2;
            const lowerHandleLeft = this.lowerHandle.getBoundingClientRect().left;
            const upperHandleRight = this.upperHandle.getBoundingClientRect().right;
            const spaceBetween = upperHandleRight - lowerHandleLeft;
            const lowerHandleRelativeLeft = lowerHandleLeft - containerLeft;
            const leftPercent = ((lowerHandleRelativeLeft + spaceBetween / 2) / containerWidth) * 100;
            const tooltipWidth = this.collapsedTooltip.getBoundingClientRect().width;
            const handleMiddle = lowerHandleLeft + spaceBetween / 2;
            const tooltipRight = handleMiddle + tooltipWidth / 2;
            const tooltipLeft = handleMiddle - tooltipWidth / 2;
            // When we set position center where the collapsed toolTip gonna be.
            const futureLeft = containerWidth * (leftPercent / 100) - tooltipWidth / 2 + containerLeft;
            if (tooltipRight >= containerRight || futureLeft + tooltipWidth >= containerRight) {
                this.setCollapsedTooltipPositionRight();
            }
            else if (tooltipLeft <= containerLeft || futureLeft <= containerLeft) {
                this.setCollapsedTooltipPositionLeft();
            }
            else {
                this.setCollapsedTooltipPositionCenter(`${leftPercent}%`);
            }
        }
    }
    setCollapsedTooltipPositionRight() {
        const collapsedTooltipStyles = {
            left: 'auto',
            right: '0px',
            transform: 'none',
        };
        this.setState({
            collapsedTooltipStyles,
        });
    }
    setCollapsedTooltipPositionLeft() {
        const collapsedTooltipStyles = {
            left: '0px',
            right: 'auto',
            transform: 'none',
        };
        this.setState({
            collapsedTooltipStyles,
        });
    }
    setCollapsedTooltipPositionCenter(left) {
        const collapsedTooltipStyles = {
            left,
            right: 'auto',
            transform: 'translateX(-50%)',
        };
        this.setState({
            collapsedTooltipStyles,
        });
    }
    collapseTooltips() {
        if (!this.state.tooltipsCollapsed) {
            this.setState({
                tooltipsCollapsed: true,
            }, () => this.setCollapsedTooltipPosition());
        }
    }
    unCollapseTooltips() {
        if (this.state.tooltipsCollapsed) {
            this.setState({
                collapsedTooltipStyles: {},
                tooltipsCollapsed: false,
            });
        }
    }
    handleTooltip(handle, tooltip) {
        if (!this.sliderContainer || !handle || !tooltip) {
            return;
        }
        const containerPadding = 10;
        const tooltipLeftClass = 'slider__tooltip--left';
        const tooltipRightClass = 'slider__tooltip--right';
        const containerRect = this.sliderContainer.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const handleRect = handle.getBoundingClientRect();
        const containerLeft = containerRect.left - containerPadding;
        const containerRight = containerRect.right + containerPadding;
        const toolTipLeft = containerLeft - handleRect.left;
        // Handle left side collapsing
        if (tooltipRect.left < containerLeft && !tooltip.classList.contains(tooltipLeftClass)) {
            tooltip.classList.add(tooltipLeftClass);
            tooltip.setAttribute('style', `left: ${toolTipLeft}px`);
        }
        else if (tooltip.classList.contains(tooltipLeftClass)) {
            if (handleRect.left + handleRect.width / 2 - containerLeft > tooltipRect.width / 2) {
                tooltip.removeAttribute('style');
                tooltip.classList.remove(tooltipLeftClass);
            }
            else {
                tooltip.setAttribute('style', `left: ${toolTipLeft}px`);
            }
        }
        const toolTipRight = handleRect.right - containerRight;
        // Handle right side collapsing
        if (tooltipRect.right > containerRight && !tooltip.classList.contains(tooltipRightClass)) {
            tooltip.classList.add(tooltipRightClass);
            tooltip.setAttribute('style', `right: ${toolTipRight}px`);
        }
        else if (tooltip.classList.contains(tooltipRightClass)) {
            if (containerRight - (handleRect.right - handleRect.width / 2) > tooltipRect.width / 2) {
                tooltip.removeAttribute('style');
                tooltip.classList.remove(tooltipRightClass);
            }
            else {
                tooltip.setAttribute('style', `right: ${toolTipRight}px`);
            }
        }
    }
    onUpdate(values) {
        if (this.sliderContainer) {
            const sliderTooltips = this.sliderContainer.querySelectorAll('.slider__tooltip');
            this.lowerTooltip = sliderTooltips[0];
            this.upperTooltip = sliderTooltips[1];
        }
        const numberValue = this.toNumber(values);
        const start = Array.isArray(numberValue) && numberValue.length === 1 ? numberValue[0] : numberValue;
        if (this.isValueDisabled(start)) {
            this.changeToOldValue();
            return;
        }
        this.handleChange();
        this.setState({
            value: this.toNumber(values),
        });
    }
    changeValue(values) {
        const numberValue = this.toNumber(values);
        const start = Array.isArray(numberValue) && numberValue.length === 1 ? numberValue[0] : numberValue;
        if (this.isValueDisabled(start)) {
            this.changeToOldValue();
            return;
        }
        if (this.props.onChange) {
            this.props.onChange(start);
        }
    }
    isValueDisabled(values) {
        if (Array.isArray(values) && this.props.pips) {
            const valueOnePip = this.props.pips.find((pip) => pip.value === values[0]);
            const valueTwoPip = this.props.pips.find((pip) => pip.value === values[0]);
            return this.isPipDisabled(valueOnePip) || this.isPipDisabled(valueTwoPip);
        }
        else if (!Array.isArray(values) && this.props.pips) {
            const valuePip = this.props.pips.find((pip) => pip.value === values);
            return this.isPipDisabled(valuePip);
        }
        return false;
    }
    isPipDisabled(pip) {
        return (pip && pip.disabled) || false;
    }
    getPrecision(a) {
        if (!isFinite(a)) {
            return 0;
        }
        let e = 1;
        let p = 0;
        while (Math.round(a * e) / e !== a) {
            e *= 10;
            p++;
        }
        return p;
    }
    setUnit(unit = '') {
        return {
            from: (value) => Number(unit ? value.replace(' ' + unit, '') : value),
            to: (value) => (unit ? this.getFixedNumber(value) + ' ' + unit : this.getFixedNumber(value)),
        };
    }
    getFixedNumber(value) {
        return this.props.step ? value.toFixed(this.getPrecision(this.props.step)) : value.toFixed();
    }
    toNumber(values) {
        return Array.isArray(values) ? values.map((value) => parseFloat(String(value))) : parseFloat(String(values));
    }
    onPipClick(value) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
        if (this.slider) {
            this.slider.set(value);
        }
    }
    getPipStyle(value, position) {
        const { range, direction, pips } = this.props;
        if (!pips) {
            return;
        }
        const pipMaxWidth = 100 / pips.length;
        if ((value === range.min && direction !== 'rtl') || (value === range.max && direction === 'rtl')) {
            return {
                left: '-10px',
                maxWidth: `${pipMaxWidth}%`,
                transform: 'none',
            };
        }
        else if ((value === range.max && direction !== 'rtl') || (value === range.min && direction === 'rtl')) {
            return {
                maxWidth: `${pipMaxWidth}%`,
                right: '-10px',
                textAlign: 'right',
                transform: 'none',
            };
        }
        return {
            left: `${position}%`,
            maxWidth: `${pipMaxWidth}%`,
        };
    }
    pipBEM(pip) {
        const classArray = ['slider__pip'];
        const { value } = this.state;
        if (pip.value === value || (Array.isArray(value) && value.includes(pip.value))) {
            classArray.push('slider__pip--active');
        }
        if (pip.disabled) {
            classArray.push('slider__pip--disabled');
        }
        return classArray.join(' ');
    }
    renderPips(pips) {
        return React.createElement("div", { className: "slider__pips-wrapper" }, pips.map(this.renderPip));
    }
    getCollapsedTooltip() {
        if (!this.slider) {
            return null;
        }
        let parsedValue = '';
        const value = this.toNumber(this.slider.get());
        if (Array.isArray(value)) {
            parsedValue = value[0] !== value[1] ? `${value[0]} - ${value[1]}` : value[0];
        }
        else {
            parsedValue = value;
        }
        return (React.createElement("div", { className: "slider__tooltip slider__tooltip--collapsed", style: this.state.collapsedTooltipStyles, ref: tooltip => (this.collapsedTooltip = tooltip) },
            parsedValue,
            " ",
            this.props.unit));
    }
    render() {
        return (React.createElement("div", { className: this.BEM() },
            React.createElement("div", { className: "slider__inner", ref: slider => (this.sliderContainer = slider), disabled: this.isSliderDisabled() }),
            this.props.pips && !this.props.hidePips && this.renderPips(this.props.pips),
            this.state.tooltipsCollapsed && this.getCollapsedTooltip()));
    }
}
export default Slider;
